import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export class WidgetDateV0Utils {

  // static dd(): string {return 'dd';}
  // static mm(): string {return 'mm';}
  // static yyyy(): string {return 'yyyy';}
  // static hh(): string {return 'hh';}
  // static MM(): string {return 'MM';}

  static getDatePlaceholder(language: string, showTime?: boolean): string {
    switch (true) {
      case this.isDDMMYYYLocalization(language):
        return showTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';

      case WidgetDateV0Utils.isYYYYMMDDLocalization(language):
        return showTime ? 'yyyy/MM/dd HH:mm' : 'yyyy/MM/dd';

      case WidgetDateV0Utils.isMMDDYYYYLocalization(language):
        return showTime ? 'MM/dd/yyyy HH:mm' : 'MM/dd/yyyy';

      default :
        return showTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';
    }
  }

  static isDDMMYYYLocalization(lang: string) {
    switch (lang) {
      case 'it':
      case 'it-CH':
      case 'en-GB':
      case 'fr':
      case 'fr-BE':
        return true;
      default :
        return false;
    }
  }

  static isYYYYMMDDLocalization(lang: string) {
    switch (lang) {
      case 'fr-CA':
      case 'zh':
        return true;
      default :
        return false;
    }
  }

  static isMMDDYYYYLocalization(lang: string) {
    switch (lang) {
      case 'en':
      case 'en-US':
      case 'es-US':
        return true;
      default :
        return false;
    }
  }

  static generateStringFromNgbDateStruct(value: string, lang: string, delimiter: string, showTime: boolean): NgbDateStruct | null {
    if (showTime) {
      // console.error('TIME not implemented!');
    } else {
      if (value && value.length === 10) {
        const date = value.split(delimiter);
        const format = WidgetDateV0Utils.getDatePlaceholder(lang, showTime).split(delimiter);
        const dayIndex = format.indexOf('dd');
        const monthIndex = format.indexOf('mm');
        const yearIndex = format.indexOf('yyyy');
        if (dayIndex && date[dayIndex]?.length === 2 && monthIndex && date[monthIndex]?.length === 2 && yearIndex && date[yearIndex]?.length === 4) {
          return {
            day: parseInt(date[dayIndex], 10),
            month: parseInt(date[monthIndex], 10),
            year: parseInt(date[yearIndex], 10)
          };
        }
      }
    }
    return null;
  }

  static ngbDateStructToTimestamp(previewData: NgbDateStruct | null): number | null {
    if (previewData) {
      const d = new Date(previewData.year, previewData.month -1 , previewData.day +1);
      return d.getTime();
    }
    return null;
  }

  static timestampToNgbDateStruct(previewData: number): NgbDateStruct | null {
    if (previewData) {
      const d = new Date(previewData);
      return  {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
      }
    }
    return null;
  }
  static timestampToString(previewData: number, language: string) {
    let result = '';
    if (previewData) {
      const d = new Date(previewData);

      const date = {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds()
      };


      if (date && date.day !== null && date.day !== undefined && date.month !== null && date.month !== undefined && date.year !== null && date.year !== undefined) {
        result = WidgetDateV0Utils.getDatePlaceholder(language, false);
        result = result.replace('yyyy', date.year?.toString());
        if (result.includes('MM')){
          result = result.replace('MM', date.month?.toString()?.length === 2 ? date.month?.toString() : '0' + date.month?.toString());
        }
        if (result.includes('mm')) {
          result = result.replace('mm', date.month?.toString()?.length === 2 ? date.month?.toString() : '0' + date.month?.toString());
        }

        result = result.replace('dd', date.day?.toString()?.length === 2 ? date.day?.toString() : '0' + date.day?.toString());
      }
    }
    return result;
  }
}
